export { default } from './SystemUpdate.jsx';
